import { gql } from '@apollo/client';

export const LOCATION_BY_GEO_POSITION = gql`
  query LocationByGeoPosition($data: LocationByGeoPositionInput!, $skip: Boolean!) {
    locationByGeoPosition(data: $data) @skip(if: $skip) {
      id
    }
  }
`;

export const ROAD_DISTANCE = gql`
  query RoadDistance($origin: GeoCoordinate!, $destination: GeoCoordinate!, $measurementSystem: String!) {
    roadDistance(origin: $origin, destination: $destination, measurementSystem: $measurementSystem) {
      distance
      durationInSeconds
      unit
    }
  }
`;
